export default __webpack_public_path__ + "static/media/categ.2ea46050.svg";